import { postRequest, getUserInfo } from '../../../utils/utils';
import {Toast} from 'antd-mobile';
// ------------------------------------
// Constants
// ------------------------------------
export const BUKA_LIST = 'BUKA_LIST'

// ------------------------------------
// Actions
// ------------------------------------
export const getBuka = (pagesize,oldData,type, keyword) => {
    return async (dispatch, getState) => {
        postRequest(`/bk/getlist`, `keyword=${keyword || ''}&&page_size=${pagesize}`).then((value) => {
            //console.log(value);
            if(value.status === 0) {
                dispatch({ type: BUKA_LIST, payload:{hasdata: false , listdata:[],count:0} })
                if(value.msg.indexOf('请登陆') !== -1) {
                    localStorage.removeItem('daka_token')
                    Toast.info('账号已在别处登录,请重新登录',2)
                    this.props.history.push('/')
                }
            } else {
                if(value.data!='') {
                    let newlist=[];
                    newlist = value.data.list
                    if(oldData && oldData.length > 0) {
                        newlist = oldData.concat(value.data.list)
                    }
                    dispatch({type: BUKA_LIST, payload: {listdata: newlist,hasdata: true,count:value.data.count }})
                }
                else {
                    dispatch({ type: BUKA_LIST, payload:{hasdata: false , listdata:[],count:0} })
                }
            }
        })
    }
}

export const getBukaChecklist = (pagesize,oldData,type, keyword) => {
    return async (dispatch, getState) => {
        postRequest(`/bk/shenhe`, `keyword=${keyword || ''}&&page_size=${pagesize}`).then((value) => {
console.log(value);
            if(value.status === 0) {
                dispatch({ type: BUKA_LIST, payload:{checklistdata:[],hascheckdata: false,count2:0 } })
                if(value.msg === '请登陆！') {
                    localStorage.removeItem('daka_token');
                    Toast.info('账号已在别处登录,请重新登录',2)
                    this.props.history.push('/')
                }
            } else {
                 if(value.data!=''){
                     let newlist=[];
                     newlist = value.data.list
                     if(oldData && oldData.length > 0) {
                         newlist = oldData.concat(value.data.list)
                     }
                     dispatch({ type: BUKA_LIST, payload:{checklistdata: newlist,hascheckdata: true,count2:value.data.count } })
                 }
                 else {
                     //alert(value.msg)
                     dispatch({ type: BUKA_LIST, payload:{checklistdata:[],hascheckdata: false,count2:0 } })
                 }
            }
        })
    }
}

export const deleteBuka = (body,history) => {
    return async (dispatch, getState) => {
        postRequest(`/bk/del`, body).then((value) => {
            //console.log(value);
            if(value.status === 0) {
                Toast.info(value.msg, 1);
                if(value.msg === '请登陆！') {
                    localStorage.removeItem('daka_token')
                    Toast.info('账号已在别处登录,请重新登录',2)
                    this.props.history.push('/')
                }
            } else {
                Toast.success('删除成功！', 1);
                dispatch(getBuka());
            }
        })
    }
}

